// Live migration dashboard SHELL. The reactive data source (migrations /
// channels / telemetry queries) lands in Phase 2; today there are no migrations,
// so this shows an honest empty state with the stat scaffold in place. When the
// Convex queries exist, they drop straight into these tiles + the scoreboard.
export function LiveDashboard({ tenantName }: { tenantName: string }) {
  const stats = [
    { k: "Messages moved", v: "—" },
    { k: "Channels", v: "—" },
    { k: "Media staged", v: "—" },
    { k: "Status", v: "Idle" },
  ];

  return (
    <div className="stack" style={{ gap: 20 }}>
      <div className="dash-grid">
        {stats.map((s) => (
          <div className="stat" key={s.k}>
            <div className="k">{s.k}</div>
            <div className="v">{s.v}</div>
          </div>
        ))}
      </div>

      <div className="empty">
        <div className="empty-ico" aria-hidden="true">
          🛰️
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <h3 style={{ fontFamily: "var(--font-display)", fontSize: "1.2rem" }}>
            No migrations yet
          </h3>
          <span className="soon-tag">Live in Phase 2</span>
        </div>
        <p className="muted" style={{ maxWidth: "54ch" }}>
          When {tenantName} starts a migration, this dashboard subscribes to a
          live stream — per-channel progress bars, running totals, and a
          log update here in real time, no refresh needed.
        </p>
        <span className="pill" style={{ marginTop: 4 }}>
          <span className="dot-live" /> Reactive dashboard ready
        </span>
      </div>
    </div>
  );
}
